var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-selector"},[_c('div',{style:({color: _vm.currentState.color})},[_vm._v("\n    "+_vm._s(_vm.currentState.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }